// extracted by mini-css-extract-plugin
export default {"skeleton-banner-card":"xd6_lK"};